import { useLayoutEffect } from 'react';
import Header from '../header/Header';
import Footer from '../footer/Footer';
import { Outlet, useLocation } from 'react-router-dom';

const Layout = () => {
    const { pathname } = useLocation();

    useLayoutEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [pathname]);

    return (
        <>
            <Header />
            <Outlet />
            <Footer />
        </>
    );
}

export default Layout;